
const NonInteractionSelfieOnly = {
    ModalCamera: {
        lb : "none_selfieOnly_cameraPermission",
        ac : null,
    },
    DicasSelfie: {
        lb : "none_selfieOnly_selfieTips",
        ac : 'modal_view_none',
    },
    Selfie: {
        lb : "success_selfieOnly_selfieToken",
        ac : null,
    },
    SelfieReady: {
        lb: 'none_selfieOnlyReady_selfie',
        ac : "screen_view_none",
    },
    SelfieError: {
        lb : "selfieError2_user&nomBlocker&NaoConseguimosTirarAFotoDoSeuRosto_selfieOnly",
        ac : null,
    },
    Analise1: {
        lb : "step1_selfieOnly_preparingData",
        ac : null,
    },
    Analise2: {
        lb : "step2_selfieOnly_sendingData",
        ac : null,
    },
    Analise3: {
        lb : "step3_selfieOnly_AnalyzingDataStarted",
        ac : null,
    },
    Analise4: {
        lb : "step3_selfieOnly_validationDone",
        ac : null,
    },
    ErroAnalise2: {
        lb : "step2_selfieOnly_failedToSendData",
        ac : "screen_view_text",
    },
    HeaderDefault: {
        lb : "exit_none_none",
        ac : "box_view_none",
        fluxo: false
    }
}

const NonInteractionDoc = {
    ModalCamera: {
        lb : "none_doc_cameraPermission",
        ac : null,
    },
    DicasSelfie: {
        lb : "none_doc_selfieTips",
        ac : 'modal_view_none',
    },
    Selfie: {
        lb : "success_doc_selfieToken",
        ac : null,
    },
    SelfieReady: {
        lb: 'none_docReady_selfie',
        ac : "screen_view_none",
    },
    SelfieError: {
        lb : "selfieError2_user&nomBlocker&NaoConseguimosTirarAFotoDoSeuRosto_doc",
        ac : null,
    },
    Analise1: {
        lb : "step1_doc_preparingData",
        ac : null,
    },
    Analise2: {
        lb : "step2_doc_sendingData",
        ac : null,
    },
    Analise3: {
        lb : "step3_doc_AnalyzingDataStarted",
        ac : "screen_view_text",
    },
    Analise4: {
        lb : "step3_doc_validationDone",
        ac : "screen_view_text",
    },
    ErroAnalise2: {
        lb : "step2_doc_failedToSendData",
        ac : "screen_view_text",
    },
    DicasDocsCnh: {
        lb : "none_doc_driversLicenseTips",
        ac : 'modal_view_none',
    },
    DicasDocsRg: {
        lb : "none_doc_idCardTips",
        ac : 'modal_view_none',
    },
    DicasDocsOutros: {
        lb : "none_doc_otherDocumentsTips",
        ac : 'modal_view_none',
    },
    SuccessCaptureFrontDocCnh: {
        lb : "success_doc_driversLicenseFrontPictureToken",
        ac : null,
    },
    SuccessCaptureFrontDocRg: {
        lb : "success_doc_idCardFrontPictureToken",
        ac : null,
    },
    SuccessCaptureFrontDocOutros: {
        lb : "success_doc_otherDocumentsFrontPictureToken",
        ac : null,
    },
    SuccessCaptureBackDocCnh: {
        lb : "success_doc_driversLicenseBackPictureToken",
        ac : null,
    },
    SuccessCaptureBackDocRg: {
        lb : "success_doc_idCardBackPictureToken",
        ac : null,
    },
    SuccessCaptureBackDocOutros: {
        lb : "success_doc_otherDocumentsBackPictureToken",
        ac : null,
    },
    ModalPermitirAcessoDocumentosCnhDigital: {
        lb : "none_doc_accessDocumentsAndFiles",
        ac : "screen_view_alert",
    },
    SucessoCnhDigital: {
        lb : "none_doc_attachedDocument",
        ac : "screen_view_none",
    },
    ErroUploadCnhDigital: {
        lb : "error_doc_cantAttachedYourCnh",
        ac : "screen_view_error",
    },
    ErroAcessoCnhDigital: {
        lb: "error_doc_cantAccessYourDocuments",
        ac: "screen_view_error",
    },
    HeaderDefault: {
        lb : "exit_none_none",
        ac : "box_view_none",
        fluxo: false
    },

}

export default {

    NonInteractionDoc,
    NonInteractionSelfieOnly

}



// WEBPACK FOOTER //
// ./src/utils/enumNonInteraction.js